import { Button } from "antd";
import { TreeState } from "cp-react-tree-table";
import { Plus } from "lucide-react";
import { FC, memo, useEffect, useState } from "react";
import { withProcedureWraper } from "../..";
import { checkLoggingStatus } from "../../../../constants/statusConstants";
import { checkingAcessToken } from "../../../../helper/util";
import { DecentralizationGroupsService } from "../../../../services/decentralization/decentralization.service";
import { useSelector } from "../../../../store/store";
import PermissionList from "./components/permission-list";

export const SettingDecentralizationPageV2: FC = withProcedureWraper(
  memo(() => {
    const user = useSelector((state) => state.user);
    const mainState = useSelector((state) => state.main);
    const [groups, setGroups] = useState<any>();
    const [open, setOpen] = useState(false);

    const getData = () => {
      DecentralizationGroupsService.getGroups()
        .then((data) => {
          let treeData: any = [];
          if (data?.length > 0) {
            data.forEach((p: any) => {
              let item: any = p;
              treeData.push({
                data: item,
              });
            });
          }
          if (treeData.length > 0) {
            const temp = TreeState.create(treeData);
            setGroups(TreeState.expandAll(temp));
          } else {
            setGroups(TreeState.createEmpty());
          }
        })
        .catch((error) => {
          console.error(error);
        });
    };

    useEffect(() => {
      if (checkingAcessToken(user, mainState) !== checkLoggingStatus.OK) {
        return;
      }

      if (groups) return;

      getData();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mainState.isExpiredToken, mainState.isUnauthorized]);

    return (
      <div className="px-4 mt-10">
        <div className="flex justify-end mb-3">
          <Button ghost type="primary" icon={<Plus size={16} />} onClick={() => setOpen(true)} />
        </div>
        <PermissionList open={open} setOpen={setOpen} />
      </div>
    );
  }),
);
